import { Box3, BoxBufferGeometry, Group, Mesh, MeshStandardMaterial, Vector3 } from "three";

export const getGroupSize = (group: Group | Mesh) => {
    const size = new Vector3();
    const aabb = new Box3().setFromObject(group);
    aabb.getSize(size);
    return {
        size: size,
        aabb: aabb,
    }
}
export const createBboxMesh = (group: Group | Mesh) => {
    const size = getGroupSize(group).size

    const bBoxGeom = new BoxBufferGeometry(size.x, size.y, size.z);
    const bBoxMaterial = new MeshStandardMaterial({ color: "#00FF80", opacity: 0.2, transparent: true });
    return new Mesh(bBoxGeom, bBoxMaterial);
};
